<template>
    <div>
    <mdb-row>
      <mdb-col md="6">
        <label class="form__label">¿Laboras actualmente?</label>
        <div v-if="userLaborData.working" class="form__check">
          <input type="radio" id="laboraSi" v-model="userLaborData.working" :value="true" disabled />
          <label for="laboraSi">
            <span :class="'form__label-active'"></span>
            Si
          </label>
        </div>
        <div v-else class="form__check">
          <input type="radio" id="laboraNo" v-model="userLaborData.working" :value="false" disabled />
          <label for="laboraNo">
            <span :class="!work ? 'form__label-active' : ''"></span>
            No
          </label>
        </div>
      </mdb-col>
    </mdb-row>
    <div v-if="userLaborData.working">
      <mdb-row>
        <mdb-col md="6" sm="8" sx="12" style="margin-bottom: 10px">
          <div class="form__group">
            <label class="form__label">Nombre de la empresa:</label>
            <input type="text" :value="this.userLaborData.company" disabled class="form__input" />
          
          </div>
        </mdb-col>
        <mdb-col md="6" sm="8" sx="12" style="margin-bottom: 10px">
          <div class="form__group">
            <label for="input_profesion" class="form__label">Profesión:</label>
            <input :value="userLaborData.profession" type="text" id="input_profesion"  disabled class="form__input" />
          </div>
        </mdb-col>
      </mdb-row>

      <mdb-row>
        <mdb-col md="6" sm="8" sx="12" style="margin-bottom: 10px">
          <div class="form__group">
            <label class="form__label"
              >Puesto:</label
            >
            <input type="text" :value="this.userLaborData.position" disabled class="form__input" />
          
          </div>
        </mdb-col>
         <mdb-col md="6" sm="8" sx="12" style="margin-bottom: 10px">
          <div class="form__group">
            <label for="input_giro" class="form__label"
                          >Giro de la empresa:</label
                        >
                        <input
                        :value="userLaborData.businessActivity"
                          type="text"
                          id="input_giro"
                          class="form__input"
                         disabled
                        />
          </div>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12"  style="margin-bottom: 10px">
          <div class="form__group">
             <label for="input_direccion" class="form__label"
                          >Dirección de la empresa:</label
                        >
                        <input
                        :value="userLaborData.addressCompany"
                          type="text"
                          id="input_direccion"
                          class="form__input"
                          disabled
                        />
          </div>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="6" sm="8" sx="12" style="margin-bottom: 10px">
         <div class="form__group">
          <label class="form__label"
            >Tel. de la empresa o lugar de trabajo:</label
          >
          <input
            type="text"
            :value="this.userLaborData.phone"
            disabled
            class="form__input"
           
          />
         
        </div>
      </mdb-col>
      <mdb-col md="6"></mdb-col>
      </mdb-row>
      <mdb-row class="mt-5">
          <mdb-col md="12">
              <label class="form__label">Constancia de situación fiscal:</label>
              	<btn type="primary" @onClick="$refs.confirm.toggleModal()" text="Ver Constancia de situación fiscal" icon="revisar" class="btn-acta-nacimiento" />
          </mdb-col>
      </mdb-row>
      
    </div>
    <div v-else>
      <mdb-row>
        <mdb-col md="10">
          <label for="input_name" class="form__label">¿A qué te dedicas?</label>
          <textarea
          :value="userLaborData.activityDescription"
            class="form-control"
            rows="5"
            maxlength="150"
            placeholder="Describe a qué se dedica"
            style="font-size: 15px; font-weight: 600; color: #000"
            disabled
          >
          </textarea>
          <!-- <validation-error
                          :validation="$v.nameCompany"
                        ></validation-error> -->
        </mdb-col>
      </mdb-row>
    </div>


		<Popup size="lg" ref="confirm" title="Constancia de situación fiscal"> 
			<div class="embed-responsive embed-responsive-16by9 z-depth-1-half" style="height: 75vh;">
                    <iframe title="Constancia de situación fiscal" class="embed-responsive-item" :src="this.urlDocument" allowfullscreen></iframe>
			</div>
				<div class="accordion__button">
			<btn style="float: left;" text="CERRAR" @onClick="$refs.confirm.toggleModal()" type="primary-block" />
			</div>
			</Popup>
		
	

     
    
    </div>
</template>
<script>
    import { mdbRow, mdbCol } from "mdbvue"; 
    import { mapGetters, mapActions } from "vuex";
    import Popup from "../../core/Popup"
    import Btn from '../../core/Button';

    export default {
        name: "BeneficiaryWorkingData",
        components: {
            mdbRow,
            mdbCol,
            Btn,
            Popup
        },
        
        computed: {
            ...mapGetters({
                laboralData: "getUserLaboralData"
            }),
            userLaborData(){
                return this.laboralData
            }
        },

        data(){
            return {
                infoIdIcon: 'info-default.svg',
                email: "",
                urlDocument: "",
                work: true
            }
        },
        created(){
	
 				let userAllData = JSON.parse(localStorage.getItem("userAllData"))
				

                for (let i = 0; i < userAllData.documents.length; i++){
						let documents = userAllData.documents[i]
						//console.log("documents", documents.documentType );
						
						if(documents.documentType == "TAX_STATUS_LETTER"){
							this.urlDocument = documents.publicURL;
						}
    			}
				
		},
        methods: {
            chooseFile(){
                document.getElementById("fileUpload").click();
            },
            chooseFileCurp(){
                document.getElementById("fileUploadCurp").click();
            },
            chooseFileColonia(){
                document.getElementById("fileUploadColonia").click();
            },
            chooseFileCartaAntec(){
                document.getElementById("fileUploadCartaAntec").click();
            },
            chooseFileIdentificacion(){
                document.getElementById("fileUploadIdentificacion").click();
            },
            mouseOverIcon(){
                let infoIdIcon = this.infoIdIcon.split("-");
                this.infoIdIcon = `${infoIdIcon[0]}-hover.svg`;
            },
            mouseLeaveIcon(){
                let infoIdIcon = this.infoIdIcon.split("-");
                this.infoIdIcon = `${infoIdIcon[0]}-default.svg`;
            },
            
            handleAuth() {
                this.$v.$touch();
                //console.log("handleAuth ...");
                
            },

          
        }

    }
</script>
<style>
    .t1-input-colonia {
        /* max-width: 80%; */
        display: inline;
        transform: translateY(3px);
        margin-bottom: 10px !important; 
    }

    .t1-input-curp {
        display: inline; 
        max-width: 70%; 
        transform: translateY(3px);
    }
    
    .t1-input-dia,
    .t1-input-mes {
        text-align: center;
        display: inline; 
        width: 8%; 
        margin-right: 15px; 
        transform: translateY(3px);
    }

    .t1-input-ano {
        text-align: center; 
        display: inline; 
        width: 12%; 
        transform: translateY(3px);
    }

    .btn-comprobante-domicilio {
        /* margin-left: 10px; */
        display: inline;
    }

    .btn-acta-nacimiento {
        display: inline-block; 
        margin-left: 10px;
    }

    .btn-upload-curp {
        display: inline; 
        margin-left: 10px;
    }

    .info-icon {
        width: 2rem;
        height: 2rem;
        margin-left: 1rem;
        transition: transform .2s;
    }

    .info-icon:hover {
        transform:  scale(1.3);
    }

    @media(max-width: 1199px){
        .t1-input-curp {
            display: block; 
            max-width: 100%; 
            transform: translateY(3px);
        }

        .t1-input-dia,
        .t1-input-mes {
            width: 12%; 
        }


        .t1-input-ano {
            width: 18%; 
        }

        .btn-upload-curp {
            display: block; 
            margin-top: 10px;
            margin-left: 0px;
        }

        .btn-acta-nacimiento {
            display: block; 
            margin-left: 0px;
            margin-top: 10px;
        }
    }

    @media(max-width: 992px){
        .btn-comprobante-domicilio {
            margin-left: 0px;
            display: block;
        }

        .t1-input-dia,
        .t1-input-mes {
            width: 18%; 
        }


        .t1-input-ano {
            width: 28%; 
        }
        

        .t1-input-colonia {
            max-width: 100%;
            margin-bottom: 10px;
            display: block;
        }   
    }

    @media(max-width: 768px){
        .t1-input-colonia {
            max-width: 100%;
        }
    }

    @media (max-width: 576px) { 
        
     }
</style>